/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=4b35675e&scoped=true&"
import script from "./text-editor.vue?vue&type=script&lang=js&"
export * from "./text-editor.vue?vue&type=script&lang=js&"
import style0 from "./text-editor.vue?vue&type=style&index=0&id=4b35675e&prod&lang=scss&"
import style1 from "./text-editor.vue?vue&type=style&index=1&id=4b35675e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35675e",
  null
  
)

export default component.exports